// MfaGate.tsx — SMS verify-code form. The recaptcha host lives at
// the app root (App.tsx) because beginMfa() runs while the gate is
// still showing, before this component would mount.

import { useState } from 'react';
import { useAuth } from '@/services/useAuth';

export function MfaGate() {
  const { mfaHint, verifyMfaCode, cancelMfa, errorMessage } = useAuth();
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleVerify() {
    if (submitting) return;
    if (!/^\d{6}$/.test(code)) return;
    setSubmitting(true);
    try {
      await verifyMfaCode(code);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="console-splash mfa-gate">
      <h2>Verification Required</h2>
      <p
        style={{
          color: 'var(--text-secondary)',
          fontSize: '0.85rem',
        }}
      >
        {mfaHint ?? 'Enter the 6-digit verification code sent to your phone'}
      </p>
      <input
        type="text"
        maxLength={6}
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="one-time-code"
        placeholder="000000"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleVerify();
        }}
        disabled={submitting}
      />
      <button
        className="btn-verify"
        type="button"
        onClick={handleVerify}
        disabled={submitting || code.length !== 6}
      >
        {submitting ? 'Verifying…' : 'Verify'}
      </button>
      <button className="btn-cancel" type="button" onClick={cancelMfa}>
        Cancel
      </button>
      {errorMessage && <p className="error-msg">{errorMessage}</p>}
    </div>
  );
}
